// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/Users/hejing/codes/smart/packages/webApp/src/models/EntryStoreModel';
import model_2 from '/Users/hejing/codes/smart/packages/webApp/src/models/UserManagementStoreModel';
import model_3 from '/Users/hejing/codes/smart/packages/webApp/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: 'EntryStoreModel', model: model_1 },
model_2: { namespace: 'UserManagementStoreModel', model: model_2 },
model_3: { namespace: '@@initialState', model: model_3 },
} as const
